import Select from "react-select"
import { CommonStyle } from "../CommonStyle/CommonStyle"

const dayOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
]

export const DayDDL = ({ DayID, setDayID }) => {
    const handleChangeDay = (option) => {
        setDayID({
            ...DayID,
            ID: option.value,
            Label: option.label
        })
    }

    const handleClearDay = () => {
        setDayID({ 
            ...DayID, 
            ID: "", 
            Label: "Day..." 
        })
    }

    return (
        <div className="d-flex align-items-center" style={{ marginTop: "-2px" }}>
            <Select
                isClearable
                id="dayDDL"
                isSearchable={false}
                maxMenuHeight={180}
                value={DayID.ID ? { value: DayID.ID, label: DayID.Label } : null}
                onChange={(option) => option ? handleChangeDay(option) : handleClearDay()}
                options={DayID.DDL}
                placeholder="Day..."
                styles={CommonStyle}
            />
        </div>
    )
}

export { dayOptions }
